var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2082 18.4997H10.7915",
    stroke: "#545565",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 26.2087V10.792",
    stroke: "#545565",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5002 33.9163C27.0146 33.9163 33.9168 27.0141 33.9168 18.4997C33.9168 9.98528 27.0146 3.08301 18.5002 3.08301C9.98577 3.08301 3.0835 9.98528 3.0835 18.4997C3.0835 27.0141 9.98577 33.9163 18.5002 33.9163Z",
    stroke: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/round-plus.ae93fe0872e2612e2a33f9aac2a5e200.svg";
export { ForwardRef as ReactComponent };